import {MapContainer, TileLayer, WMSTileLayer, useMap, GeoJSON, useMapEvent, ZoomControl, Popup, Marker} from 'react-leaflet';
import {connect, useDispatch} from "react-redux";
import React from "react";
import L from 'leaflet'

import {changeMapZoom, updateSld} from "../actions";

import popup_preloaded from '../utils/data_popup.json';
import { HearingDisabledSharp } from '@mui/icons-material';

const mapStateToProps = state => {
    return {
        map: state.MapReducer
    }
};

function ClickEvent(props) {
    let marker = null;
    const map = useMapEvent('click', (e)=>{
        if([
            "allum_project:settlements_1785",
            "allum_project:settlements_1910",
            "allum_project:settlements_2018"
        ].indexOf(props.activeLayer)===-1){
            return;
        }
        Object.keys(map._layers).map(_lk=>{
            let _l = map._layers[_lk];
            if(_l.options.ltype==='marker')
                map.removeLayer(_l)
        })

        // marker = L.marker([e.latlng.lat, e.latlng.lng], {ltype: 'marker'})
        // marker.addTo(map)

        var sw = map.options.crs.project(map.getBounds().getSouthWest());
        var ne = map.options.crs.project(map.getBounds().getNorthEast());
        var BBOX = sw.x + "," + sw.y + "," + ne.x + "," + ne.y;
        var WIDTH = map.getSize().x;
        var HEIGHT = map.getSize().y;

        var X = Math.trunc(map.layerPointToContainerPoint(e.layerPoint).x);
        var Y = Math.trunc(map.layerPointToContainerPoint(e.layerPoint).y);
        var URL = 'http://193.225.239.5/geoserver/allum_project/wms?'+
                    'SERVICE=WMS&VERSION=1.1.1&REQUEST=GetFeatureInfo&'+
                    'LAYERS='+props.activeLayer+'&QUERY_LAYERS='+props.activeLayer+'&'+
                    'BBOX='+BBOX+'&FEATURE_COUNT=1&HEIGHT='+HEIGHT+'&WIDTH='+WIDTH+'&'+
                    'INFO_FORMAT=application%2Fjson&TILED=false&CRS=EPSG%3A3857&X='+X+'&Y='+Y+'';

        const categories = {};
        for (const item of popup_preloaded) {
            if(item.layer===props.activeLayer) {
                if (item.category in categories) {
                    categories[item.category].push(item);
                } else {
                    categories[item.category] = [item];
                }
            }
        }
        const cat={};
        
        fetch(URL).then(r=>r.json()).then(r=>{
            if(r.features.length===0)
                return
            let feature = r.features[0];
            let html = "<div style='max-height:200px; overflow-y:auto; padding-right:10px;'>";

            Object.entries(categories).map((entry) => {
                const popup_category = entry[0];
                const itemList = entry[1];

                if(popup_category=="Base data"){
                    html += "<button class='popup_accordion active'><i id='arw' class='arrow down'></i><b>"+popup_category+"</b></button>"
                    html += "<div class='popup_panel' style='display:block'>"
                } else {
                    html += "<button class='popup_accordion'><i id='arw' class='arrow right'></i><b>"+popup_category+"</b></button>"
                    html += "<div class='popup_panel'>"
                }

                Object.keys(feature.properties).map(fp=>{
                    const found = popup_preloaded.find(obj => {
                        return (obj.field === fp && obj.layer === props.activeLayer);
                    });
                
                    if(found) {
                        if(found.category==popup_category) {
                            if(fp.startsWith('popup_') || fp.startsWith('p_')){
                                if(feature.properties[fp]==null || feature.properties[fp]=="") {
                                    feature.properties[fp]="no data";
                                }
                                if(feature.properties[fp]=="HAMIS") { feature.properties[fp]="No"}
                                if(feature.properties[fp]=="IGAZ") { feature.properties[fp]="Yes"}
                                html += "<div class='popup_row'>"+found.title+": <b>"+feature.properties[fp]+"</b></div>"
                            }
                        }
                    }   
                })

                html += "</div>"
                    
            })

            html +='</div>';

            marker = L.popup()
            .setLatLng([e.latlng.lat, e.latlng.lng])
            .setContent(html)
            .openOn(map);

            var acc = document.getElementsByClassName("popup_accordion");
            var i;
        
            marker.on('popupclose', (e)=>{
                Object.keys(map._layers).map(_lk=>{
                    let _l = map._layers[_lk];
                    if(_l.options.ltype==='marker')
                        map.removeLayer(_l)
                })
            })
            marker._closeButton.onclick = function( ){
                Object.keys(map._layers).map(_lk=>{
                    let _l = map._layers[_lk];
                    if(_l.options.ltype==='marker')
                        map.removeLayer(_l)
                })
            }

            /* Popup accordion events */
            for (i = 0; i < acc.length; i++) {
                acc[i].addEventListener("click", function() {
                    this.classList.toggle("active");
                    var arw = this.firstElementChild;
                    var panel = this.nextElementSibling;
                    if (panel.style.display === "block") {
                        panel.style.display = "none";
                        arw.className="arrow right";
                    } else {
                        panel.style.display = "block";
                        arw.className="arrow down";
                    }
                });
            }
            /* Popup accordion events END */

            let wfsUrl = 'http://193.225.239.5/geoserver/allum_project/ows?'
            +'service=WFS&version=1.0.0&request=GetFeature'
            +'&typeName=' + props.activeLayer
            +'&maxFeatures=1&outputFormat=application%2Fjson'
            // +'&featureId='+feature.id
            +'&srsName=epsg:4326'
            +'&propertyname=gid,geom&cql_filter=gid=' + feature.properties.gid;
            fetch(wfsUrl).then(r=>r.json())
            .then(r=>{
                try{
                    L.geoJSON(r.features[0].geometry, {ltype:'marker'}).addTo(map)
                }catch(e){
                    console.log(e);
                }
            })
        })
    })

    return null;
}

const MapMarker = (props) => {
    return props.position?<Marker position={props.position}>
        <Popup>
            {props.content}
        </Popup>
    </Marker>:''
}

const MapLayers = (props) => {
    let layers = Object.keys(props.map.layers).map(layerId=>props.map.layers[layerId]);
    layers = layers.sort((a, b)=>{ return a.sortOrder - b.sortOrder });

    return <div>
        {
            layers.map(layer => {
                if(!layer.active)
                    return '';
                switch(layer.type){
                    case 'WMS':
                    let _params = {
                            layers: layer.id,
                            format: 'image/png',
                            tiled: true,
                            transparent: true,
                            // sld: `http://localhost:8081/getSld/${layer.sldBody}`,
                        }
                        if(layer.sldBody){
                            _params['sld'] = `http://193.225.239.5/backend2/getSld/${layer.sldBody}`;
                        }
                        return props.map.zoom>=layer.minZoom?<WMSTileLayer 
                            maxZoom={24} key={layer.id} url={layer.url} params={_params} />:''
                    case 'BASE':
                        return props.map.zoom>=layer.minZoom?<WMSTileLayer 
                            maxZoom={24} 
                            key={layer.id} 
                            url={layer.url} 
                            zIndex={layer.sortOrder} 
                            opacity={layer.opacity}
                            params={{
                                layers: props.map.enabledBmaps.join(","),
                                format: 'image/png',
                                tiled: true,
                                transparent: true,
                            }} />:''
                    case 'VECTOR':
                        return <GeoJSON attribution="&copy; credits due..." data={layer.data} key={layer.id} />
                    case 'TILE':
                        return <TileLayer key={layer.id}
                                          url={layer.url}
                                          maxZoom={24}
                        />
                    case 'VECTOR_GJ':
                        return true?(
                            <GeoJSON data={layer.data} key={layer.id} />
                        ):'';
                }
                return '';
            })

        }
    </div>
}

function ZoomEvent() {
    const dispatch = useDispatch();
    const map = useMapEvent('zoom', () => {
        dispatch(changeMapZoom(map.getZoom()))
    })
    return null
}

const Map = (props) => {

    const dispatch = useDispatch()

    const [markerPosition, setMarkerPosition] = React.useState(null);

    React.useEffect(()=>{
        
    }, [props.map.activeLayer, props.map.activeField, props.map.colorRamp])

    return (
        <MapContainer style={{height: 'calc(100vh - 0px)', width: '100%'}} center={props.map.center} zoomControl={false} attributionControl={false} zoom={props.map.zoom} >
            <ZoomControl position="topright" />
            <ZoomEvent />
            <ClickEvent activeLayer={props.map.activeLayer} />
            <MapLayers map={props.map} />
            {/*<MapMarker position={markerPosition} content={<div>sass</div>} />*/}
        </MapContainer>
    );

}

export default connect(mapStateToProps)(Map);